<script>
export default {
    name: "LPODetails",
    data () {
        return {
            purchaseOrder: {},
            lpoLines: [],
            previewWithPrices: 1,
        };
    },
    mounted () {
        this.fetchLPO();
        this.fetchLPOItems();
    },
    methods: {

        fetchLPO() {
            this.$root.loading = true;
            this.$accountsHttp.get(`SupplierLPO/PostedSpecificLPO?LPONo=${this.$route.params.LPONo}`).then(response => {
                this.purchaseOrder = response.data[0];
                this.$root.loading = false;
            }).catch(() => this.$root.loading = false);
        },

        fetchLPOItems() {
            this.$root.loading = true;
            this.$accountsHttp.get(`SupplierLPO/PostedSpecificLPODetails?LPONo=${this.$route.params.LPONo}`)
                .then(response => {
                    this.lpoLines = response.data;
                    this.$root.loading = false;
            }).catch(() => this.$root.loading = false);
        },

        printReceipt() {
            let url = `/suppliers-dashboard/purchase-orders/print`;
                url += `/${this.purchaseOrder.lpO_No}?price=${this.previewWithPrices}`;

            window.open(url,  '_blank', 'LPO Preview');
        },
    },
}
</script>
<template>
<tail-base-layout>
  <template v-slot:content>
      <tail-card>
        <template v-slot:card-header>
          <h5 class="font-medium text-sm">View Purchase Order</h5>
        </template>
        <template v-slot:card-body>
            <tail-address-header></tail-address-header>
            <div class="flex md:flex-row sm:flex-col w-full p-2 bg-gray-200 my-2">
                
                <div class="flex-1">
                    <h4 class="font-bold">Supplier: 
                        <span class="text-blue-400">{{ purchaseOrder.supplier }}</span></h4>
                </div>
                <div class="flex-1">
                    <h4 class="font-bold">Date: 
                        <span class="text-blue-400">{{ purchaseOrder.date | dateFormat }}</span></h4></div>
                <div class="flex-1">
                    <h4 class="font-bold">LPO Ref: 
                        <span class="text-blue-400">{{ purchaseOrder.lpO_No }}</span></h4></div>
                <div class="flex-1">
                    <h4 class="font-bold">Other Ref: 
                        <span class="text-blue-400">{{ purchaseOrder.ref_No }}</span></h4>
                </div>
            </div>
            <div class="flex w-full overflow-auto">
                <table class="table">
                    <thead class="bg-blue-500 text-xs text-white">
                        <tr>
                            <th class="p-tiny">Item</th>
                            <th class="p-tiny">Description</th>
                            <th class="p-tiny">Qty</th>
                            <th class="p-tiny">Unit Cost</th>
                            <th class="p-tiny">Total</th>
                            <th class="p-tiny">Grand total</th>
                        </tr>
                    </thead>
                    <tbody class="text-xs bg-gray-100">
                        <tr v-for="(lpoLine, index) in lpoLines" :key="index">
                            <td class="p-tiny">{{ lpoLine.service }}</td>
                            <td class="p-tiny">{{ lpoLine.description }}</td>
                            <td class="p-tiny">{{ lpoLine.quantity | numberFormat }}</td>
                            <td class="p-tiny">{{ lpoLine.charge | numberFormat }}</td>
                            <td class="p-tiny">{{ lpoLine.total | numberFormat }}</td>
                            <td class="p-tiny">{{ lpoLine.grandTotal | numberFormat }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="w-1/5 p-1">
                <label class="label-control text-sm" for="grid-preview-price">Show Prices On Preview</label>
                <tail-select>
                    <template v-slot:field>
                        <select v-model="previewWithPrices" 
                            id="grid-preview-price" class="input-control input-sm text-xs">
                            <option :value="0">Dont Show Prices</option>
                            <option :value="1">Show Prices</option>
                        </select>
                    </template>
                </tail-select>
            </div>
        </template>
        <template v-slot:card-footer>
           <div class="w-full text-right">
             <router-link 
                :to="{ name: `suppliers-dashboard.purchase-orders.index` }" 
                class="btn-sm btn-danger text-xs rounded mr-6">
                    <i class="fa fa-caret-left"></i> Back
            </router-link>
             <button 
                class="btn-primary btn-sm rounded text-xs" 
                @click.prevent="printReceipt()">
                    <i class="fa fa-print"></i> Preview</button>
           </div>
        </template>
      </tail-card>
  </template>
</tail-base-layout>
</template>
